import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBI-z2xvF9LMKXv-xmt3Buv9i4yvYzKP4cEY",
  authDomain: "bengsports-82320.firebaseapp.com",
  projectId: "bengsports-82320",
  storageBucket: "bengsports-82320.firebasestorage.app",
  messagingSenderId: "1024152964137",
  appId: "1:1024152964137:web:dcdde1c324f3268fb16038"
};

// ✅ Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };